// To hit a locally running MIS API instead of Azure, set LOCAL_OVERRIDE to the
// environment you want redirected ('dev' | 'test' | 'prod'). Leave '' for normal use.
const LOCAL_OVERRIDE = '';
const LOCAL_MIS_APIURL = 'http://localhost:4000/api/fieldworker';

const misApiUrl = (envName, url) => (LOCAL_OVERRIDE === envName ? LOCAL_MIS_APIURL : url);

// MIS backend per environment. The active one is chosen at runtime by the
// in-app environment toggle (see ToggleMIS).
const MIS_APIURL = {
  dev: misApiUrl('dev', process.env.REACT_APP_APIURL1),
  test: misApiUrl('test', process.env.REACT_APP_APIURL2),
  prod: misApiUrl('prod', process.env.REACT_APP_APIURL3),
};

// Onboarding API (provisions a new company + its Azure AD users), per environment.
const ONBOARD_APIURL = {
  dev: 'https://fwonboardapp.azurewebsites.net/api/fieldworker/onboard',
  test: 'https://fieldworkeronboard.azurewebsites.net/api/fieldworker/onboard',
  prod: 'https://fieldworkeronboardprod.azurewebsites.net/api/fieldworker/onboard',
};

// Main Fieldworker API + Azure AD app registration. Always prod — used for
// login and resolving the signed-in user, regardless of the MIS env toggle.
const APIURL = process.env.REACT_APP_APIURL_PROD;
const SCOPE = process.env.REACT_APP_SCOPE_PROD;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID_PROD;
const MSTENANT = process.env.REACT_APP_MSTENANT;

const MUI_KEY = process.env.REACT_APP_MATERIAL_UI_LICENSE_KEY;

export { MIS_APIURL, ONBOARD_APIURL, APIURL, SCOPE, CLIENT_ID, MSTENANT, MUI_KEY };